module.exports = __webpack_public_path__ + "static/media/furni1.77885a42.webp";